<template>
	<div>
      <v-container grid-list-xl>        
        <v-flex lg12>          
          <label class="blackLabel">Company</label>
          <v-select :items="objUserCompanies" label="Company" class="dropdown" v-model="currentUserCompany" item-value="id" autocomplete single-line solo></v-select>
        </v-flex>        
        <v-layout row wrap class="pl-4 pr-4 pt-4 pb-4">
          <div class="pl-4 pr-1 pb-2 pt-4 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
              <v-btn color="success" class="text-xs-right" @click.stop="fncUpdateUserCompany()">Save</v-btn>
            </div>
          </div>
        </v-layout>
      </v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	
              search: '',
              currentUserCompany: this.$store.getters.currentUserCompany,
			}
		},
		methods: {
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncUpdateUserStatus() {
              this.$store.dispatch('fncUpdateUserStatus', this.globalModalParams.userId);
            },
            fncEditNotifications() {
              this.$store.dispatch('fncEditNotifications', this.globalModalParams.userId);
            },
            fncReloadStatusList() {
              this.$store.dispatch({
                type: 'fncEditStatus',
                userId: this.globalModalParams.userId,
                status: this.statusType,
                showModal: false
              })              
            },
            fncUpdateUserCompany() {
              this.$store.dispatch({
                type: 'fncUpdateUserCompany',
                userId: this.globalModalParams.userId,
                company: this.currentUserCompany,
                context: this.globalModalParams.context
              })
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'objUserCompanies'                
			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>